import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';

// Shown when the browser refused to open the chat window.
//
// TeamX puts chat in a real detached window rather than a panel, so a blocked
// pop-up is not a cosmetic problem - there is no chat at all. Before this the
// failure was silent and looked like the app was broken (see ErrorBoundary for
// why it went white), so say plainly what happened and what to do about it.
//
// Styled inline rather than through a stylesheet. This renders in the main
// document today, but everything in this app has to survive being moved into a
// detached window, where MyWindowPortal's copyStyles is commented out and no
// stylesheet follows.
export class PopupBlockedDialog extends Component {
    handleRetry = () => {
        this.props.onRetry();
    };

    // What was blocked, so the message names the thing the user was actually
    // trying to open rather than always saying "chat".
    describe = () => (this.props.what ? this.props.what : 'a window it needs');

    render() {
        if (!this.props.open) {
            return null;
        }

        return (
            <Dialog
                open={true}
                onClose={this.props.onDismiss}
                aria-labelledby="popup-blocked-title"
            >
                <DialogTitle id="popup-blocked-title" disableTypography>
                    <Typography variant="title" style={{ fontWeight: 600 }}>
                        TeamX needs pop-ups allowed
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography style={{ marginBottom: '12px' }}>
                        Your browser blocked {this.describe()}, so it could not open.
                        TeamX opens this in a window of its own, which counts as a pop-up.
                    </Typography>
                    <Typography style={{ marginBottom: '12px' }}>
                        Look for the blocked pop-up icon in the address bar and choose
                        to always allow pop-ups from this site.
                        {this.props.onRetry ? ' Then use Try again below.' : ' Then open it again from the menu.'}
                    </Typography>
                    <Typography variant="caption">
                        Chrome and Edge: click the icon at the right of the address bar,
                        pick "Always allow pop-ups and redirects from this site", then
                        Done. Firefox: use the Options button on the yellow bar at the
                        top of the page.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onDismiss} color="default">
                        {this.props.onRetry ? 'Not now' : 'Close'}
                    </Button>
                    {this.props.onRetry &&
                        <Button onClick={this.handleRetry} color="primary" variant="contained">
                            Try again
                        </Button>}
                </DialogActions>
            </Dialog>
        );
    }
}

PopupBlockedDialog.propTypes = {
    open: PropTypes.bool,
    what: PropTypes.string,
    onRetry: PropTypes.func,
    onDismiss: PropTypes.func.isRequired,
};

export default PopupBlockedDialog;



// WEBPACK FOOTER //
// ./src/components/PopupBlockedDialog.js